import { financeBalanceTypes } from './balance.constants'
import {
  type FinanceBalance,
  type FinanceBalanceTicketDomainType,
  type FinanceBalanceTicketType
} from './balance.types'

const buildFinanceBalanceTicket = (
  domainTicket: FinanceBalanceTicketDomainType,
  index: number
): FinanceBalanceTicketType => {
  return {
    name: domainTicket.title,
    debtSum: domainTicket.debtSum,
    canPay: domainTicket.canPay,
    payBefore: domainTicket.dueDate,
    type: financeBalanceTypes[index],
    state: domainTicket.state,
    merchId: domainTicket.merchId
  }
}

export const FinanceBalanceMapper = {
  toEntity(domain: FinanceBalanceTicketDomainType[]): FinanceBalance {
    return {
      totalSum: domain.reduce((acc, { debtSum }) => acc + debtSum, 0),
      tickets: domain.map((ticket, index) =>
        buildFinanceBalanceTicket(ticket, index)
      )
    }
  }
}
